"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.slice.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _link = _interopRequireDefault(require("@meepshop/link"));

var _locales = require("@meepshop/locales");

var _Currency = _interopRequireDefault(require("@meepshop/context/lib/Currency"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./styles.less");

var styles = {
  "menuWrapper": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menuWrapper",
  "visible": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__visible",
  "menu": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu",
  "menu-horizontal": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-horizontal",
  "menu-horizontal-4": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-horizontal-4",
  "menuContent": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menuContent",
  "menu-horizontal-6": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-horizontal-6",
  "menu-vertical": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-vertical",
  "menu-vertical-1": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-vertical-1",
  "menu-vertical-2": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-vertical-2",
  "menu-vertical-4": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-vertical-4",
  "menu-vertical-5": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-vertical-5",
  "productHorizontal": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productHorizontal",
  "productsHorizontalContent": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productsHorizontalContent",
  "productVertical": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productVertical",
  "productTitle": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productTitle",
  "productsVerticalContent": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productsVerticalContent",
  "productImage": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productImage",
  "productContent": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productContent",
  "productPrice": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productPrice"
};

var ProductImage = function ProductImage(_ref) {
  var _placeholderThumbnail;

  var src = _ref.src,
      imageMaxWidth = _ref.imageMaxWidth,
      imageRatio = _ref.imageRatio,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: imageMaxWidth,
      minWidth: imageMaxWidth
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      aspectRatio: imageRatio
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: styles.productImage,
    src: src || ((_placeholderThumbnail = {
      w60: require("@meepshop/images/lib/getImage")["default"]({
        stage: "https://img.meepstage.com/0xHLivOJEY9HyX29GsU9-8OB0dnrv2ftf6JFpoaYcYw/w:60/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA",
        production: "https://img.meepshop.com/FvfnT7ShdWUTP7OACAFks3L9-KrwNAdtsBJ5tnMdNoE/w:60/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA"
      }),
      w120: require("@meepshop/images/lib/getImage")["default"]({
        stage: "https://img.meepstage.com/SZ_dAEBQj9Kuu2nMhtpvEJkIYrD_yYsJH0j_XfA0b7w/w:120/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA",
        production: "https://img.meepshop.com/IBmAFppYK6XalNiYfk-4RYfAPnB31FFtLDezPoYSRtM/w:120/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA"
      }),
      w240: require("@meepshop/images/lib/getImage")["default"]({
        stage: "https://img.meepstage.com/vAkblyCaeNpsi9tPgXnAPnqXioMqOji1kShJztMUW6A/w:240/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA",
        production: "https://img.meepshop.com/HfiVgW4QTRyW6sLgN90FTyHKEL9Rv7mo0UnkuSPBD0c/w:240/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA"
      }),
      w480: require("@meepshop/images/lib/getImage")["default"]({
        stage: "https://img.meepstage.com/-XfnfQPXpIulOnYomxDVjX-dCzt9Z-RE6wyL1h7-msg/w:480/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA",
        production: "https://img.meepshop.com/HVb6KSpDd5GMzohblnM0vThwkMU5SeV9ajUabyhJu60/w:480/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA"
      }),
      w720: require("@meepshop/images/lib/getImage")["default"]({
        stage: "https://img.meepstage.com/HVzGv1LUBrFk5faXJ7BplVGJoA5mBRsEUVjH6bdTe_A/w:720/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA",
        production: "https://img.meepshop.com/frNkmhw0aOgJBC1fUY2FPL0npQYCAJGoom-3pNK_XfY/w:720/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA"
      }),
      w960: require("@meepshop/images/lib/getImage")["default"]({
        stage: "https://img.meepstage.com/HJ1zdiZIHizEJBZFE-CS1Vu9kJNTmbJH5YmLpsxvCpY/w:960/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA",
        production: "https://img.meepshop.com/OE5W67FIUSf4rJSZ3GA8UpR2uhNaWGcznGe2fc_QEuk/w:960/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA"
      }),
      w1200: require("@meepshop/images/lib/getImage")["default"]({
        stage: "https://img.meepstage.com/keXl5XDr6tddp4v4PsicF5fKbiccQDds9UESasMRCh8/w:1200/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA",
        production: "https://img.meepshop.com/BDo28LaZVM3c-X0ZIAg7zgBOClFIejXFcPNePJ44sjo/w:1200/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA"
      }),
      w1440: require("@meepshop/images/lib/getImage")["default"]({
        stage: "https://img.meepstage.com/KWEwf4zINqj40k9xqUFbxRDmyfHkesvCxIGdEfvQ96M/w:1440/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA",
        production: "https://img.meepshop.com/M4ah97IuOSWv9GUm3VlzK2SOZ2aesXnnK7YwQmcOMq8/w:1440/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA"
      }),
      w1680: require("@meepshop/images/lib/getImage")["default"]({
        stage: "https://img.meepstage.com/ZNbvTrCCpSJgHbd6Ve0qfd4GBJqCiJkMLJe5GrpLbvM/w:1680/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA",
        production: "https://img.meepshop.com/Vl3Kc7FigXLJscur1XLEZEXZvKKnuWwPv6LjK6RZrA4/w:1680/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA"
      }),
      w1920: require("@meepshop/images/lib/getImage")["default"]({
        stage: "https://img.meepstage.com/fVYo3IJlZUeojZx4-WR1KvUgpHhVt-wxK7J5mEO3fVo/w:1920/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA",
        production: "https://img.meepshop.com/zxtQi9301mZFPDXPrkAhrzbb0i9VN-3C6M5R8lo7qtk/w:1920/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA"
      })
    }) === null || _placeholderThumbnail === void 0 ? void 0 : _placeholderThumbnail.w480),
    alt: title
  })));
};

var ProductPrice = function ProductPrice(_ref2) {
  var _product$variants;

  var product = _ref2.product;

  var _useContext = (0, _react.useContext)(_Currency["default"]),
      c = _useContext.c;

  var variant = (_product$variants = product.variants) === null || _product$variants === void 0 ? void 0 : _product$variants[0];
  if (!variant) return null;
  var totalPrice = variant.totalPrice,
      suggestedPrice = variant.suggestedPrice,
      listPrice = variant.listPrice;
  var displayPrice = totalPrice || suggestedPrice || listPrice;
  if (!displayPrice) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.productPrice
  }, !!displayPrice && /*#__PURE__*/_react["default"].createElement("span", null, c(displayPrice)), !!listPrice && listPrice !== displayPrice && /*#__PURE__*/_react["default"].createElement("span", null, c(listPrice)), !!suggestedPrice && suggestedPrice !== displayPrice && /*#__PURE__*/_react["default"].createElement("span", null, c(suggestedPrice)));
};

var ProductVertical = function ProductVertical(_ref3) {
  var _product$coverImage;

  var title = _ref3.title,
      product = _ref3.product,
      imageMaxWidth = _ref3.imageMaxWidth,
      imageRatio = _ref3.imageRatio;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.productVertical,
    style: {
      width: imageMaxWidth
    }
  }, /*#__PURE__*/_react["default"].createElement(ProductImage, {
    src: (_product$coverImage = product.coverImage) === null || _product$coverImage === void 0 ? void 0 : _product$coverImage.scaledSrc.w480,
    imageMaxWidth: imageMaxWidth,
    imageRatio: imageRatio,
    title: title
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.productContent
  }, /*#__PURE__*/_react["default"].createElement("h6", {
    className: styles.productTitle
  }, title), /*#__PURE__*/_react["default"].createElement(ProductPrice, {
    product: product
  })));
};

var ProductHorizontal = function ProductHorizontal(_ref4) {
  var _product$coverImage2;

  var title = _ref4.title,
      product = _ref4.product,
      imageMaxWidth = _ref4.imageMaxWidth,
      imageRatio = _ref4.imageRatio;
  var isOverLength = title.length > 27;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.productHorizontal
  }, /*#__PURE__*/_react["default"].createElement(ProductImage, {
    src: (_product$coverImage2 = product.coverImage) === null || _product$coverImage2 === void 0 ? void 0 : _product$coverImage2.scaledSrc.w480,
    imageMaxWidth: imageMaxWidth,
    imageRatio: imageRatio,
    title: title
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.productContent
  }, /*#__PURE__*/_react["default"].createElement("h6", {
    className: styles.productTitle
  }, "".concat(title.slice(0, 27)).concat(isOverLength ? '...' : '')), /*#__PURE__*/_react["default"].createElement(ProductPrice, {
    product: product
  })));
};

var Product = function Product(_ref5) {
  var product = _ref5.product,
      imageMaxWidth = _ref5.imageMaxWidth,
      imageTextAlignment = _ref5.imageTextAlignment,
      imageRatio = _ref5.imageRatio;
  var getLanguage = (0, _locales.useGetLanguage)();
  var title = getLanguage(product.title);
  var renderContent = imageTextAlignment === 'vertical' ? /*#__PURE__*/_react["default"].createElement(ProductVertical, {
    title: title,
    product: product,
    imageMaxWidth: imageMaxWidth,
    imageRatio: imageRatio
  }) : /*#__PURE__*/_react["default"].createElement(ProductHorizontal, {
    title: title,
    product: product,
    imageMaxWidth: imageMaxWidth,
    imageRatio: imageRatio
  });
  return /*#__PURE__*/_react["default"].createElement(_link["default"], {
    href: "/products/".concat(product.id)
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "/products/".concat(product.id),
    style: {
      minWidth: 0
    }
  }, renderContent));
};

var _default = Product;
exports["default"] = _default;